import React, { useContext, useState } from "react";
import { AuthContext, DeveloperContext, PagesContext } from "../../context/authContext";
import LoginPage from "../pages/LoginPage/LoginPage"
import Menu from "./menu";
import Content from "./content";
import Header from "./header";
import { appPages, devMode } from "../../common/links";

const Main = function(){
    const {isAuthenticated} = useContext(AuthContext);
    const [page, setPage] = useState(appPages[0].state);
    const [isDevMode] = useState(devMode);
  
    if (!isAuthenticated){
        return(
            
            <div id="main">
                <LoginPage/>
            </div>
        );
    }
    else return(
        <PagesContext.Provider value={{ page, setPage }}>
            <Header>
                <span className='caption'>Astro-planner - админка прогнозов</span>
            </Header>
            <div id="main">
                <DeveloperContext.Provider value={{ isDevMode }}>
                    <Menu />
                </DeveloperContext.Provider>
                <Content />
            </div>
        </PagesContext.Provider>

    );
}
export default Main;